export default {
  input: {
    language: {
      label: "System Language",
      text: "The Stickyweb display language"
    },
    name: "Name",
    email: {
      label: "Email",
      text: "When changing the email address, you will automatically be logged out.",
    }
  },
  success: {
    saved: "Account data saved",
  },
  buttons: {
    save: "Save",
  },
}
